import React from 'react';
import { Icon } from './Icon.js';
export const IconChartBubbleFill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("circle", { cx: "11.75", cy: "14", r: "2.5", fill: "currentColor" }),
        React.createElement("circle", { cx: "12.25", cy: "5.75", r: "4.25", fill: "currentColor", "data-color": "color-2" }),
        React.createElement("circle", { cx: "4.5", cy: "11", r: "3", fill: "currentColor" })));
};
//# sourceMappingURL=IconChartBubbleFill18.js.map